import { apiRequest } from "./client";

export const billingApi = {
  overview() {
    return apiRequest("/billing/overview");
  },
  runCycle(payload = {}) {
    return apiRequest("/billing/run-cycle", { method: "POST", body: payload });
  },
  listServices() {
    return apiRequest("/billing/services");
  },
  createService(payload) {
    return apiRequest("/billing/services", { method: "POST", body: payload });
  },
  updateService(serviceId, payload) {
    return apiRequest(`/billing/services/${serviceId}`, { method: "PATCH", body: payload });
  },
  getProject(projectId) {
    return apiRequest(`/billing/projects/${projectId}`);
  },
  updateProject(projectId, payload) {
    return apiRequest(`/billing/projects/${projectId}`, { method: "PATCH", body: payload });
  },
  assignService(projectId, payload) {
    return apiRequest(`/billing/projects/${projectId}/services`, { method: "POST", body: payload });
  },
  removeService(projectId, assignmentId) {
    return apiRequest(`/billing/projects/${projectId}/services/${assignmentId}`, { method: "DELETE" });
  },
  createInvoice(projectId, payload) {
    return apiRequest(`/billing/projects/${projectId}/invoices`, { method: "POST", body: payload });
  },
  createCheckout(projectId, invoiceId) {
    return apiRequest(`/billing/projects/${projectId}/invoices/${invoiceId}/checkout`, { method: "POST" });
  },
  registerManualPayment(projectId, invoiceId, payload = {}) {
    return apiRequest(`/billing/projects/${projectId}/invoices/${invoiceId}/manual-payment`, {
      method: "POST",
      body: payload,
    });
  },
  voidInvoice(projectId, invoiceId) {
    return apiRequest(`/billing/projects/${projectId}/invoices/${invoiceId}/void`, { method: "POST" });
  },
  updateFiscal(projectId, invoiceId, payload) {
    return apiRequest(`/billing/projects/${projectId}/invoices/${invoiceId}/fiscal`, {
      method: "PATCH",
      body: payload,
    });
  },
};
